import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { AuthGuard } from '../guard/auth.guard'
import { AlmacenMenajeriaComponent } from './almacen-menajeria.component'
import { InventarioComponent } from './inventario/inventario.component'

const routes: Routes = [
  {
    path: '',
    component: AlmacenMenajeriaComponent,
    children: [
      { path: '', canActivate: [AuthGuard], component: InventarioComponent }
    ]
  }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AlmacenMenajeriaRoutingModule {}
